import { lazyload } from '@/lib/lazy-load'

export const GridImportModal = lazyload(() => import('./GridImportModal'))
